<template>
    <v-select
        :label="label"
        :disabled="disabled"
        v-model.number="value"
        @change="$emit('update:input', value)"
        :items="wallets"
        item-text="name"
        item-value="id"
        prepend-icon="account_balance_wallet"
        :rules="required ? requireText : []"
    ></v-select>
</template>

<script>
export default {
    props: {
        required: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: "Hình thức thu tiền",
        },
        disabled: {
            type: Boolean,
            default: false
        },
        input: {
            type: Number,
            default: null
        }
    },
    name: "list-wallet",
    data(){
        return {
            value: '',
            requireText: [
                v => !!v || "Vui lòng nhập thông tin này",
            ],
        }
    },
    computed: {
        wallets(){
            return this.$store.state.app.wallets
        }
    },
    beforeMount(){
        this.value = this.input
    },
    watch: {
        input(nv){
            if (nv || nv === 0) this.value = nv
        }
    }
};
</script>

<style>
</style>